<div class="table-page dashboard-page">
  <header class="header">
    <div class="title-row">
      <button type="button" class="back" title="بازگشت" aria-label="بازگشت" (click)="goBack()">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
      <h1 class="title">داشبورد شیلات نگر</h1>
      <div class="actions">
        <button type="button" class="btn btn-ghost" id="filterToggle" [attr.aria-expanded]="filtersOpen"
          aria-controls="filtersWrap" (click)="filtersOpen = !filtersOpen">
          <i class="fa fa-sliders" aria-hidden="true"></i> فیلتر
          <i class="fa fa-chevron-down chev" aria-hidden="true"></i>
        </button>
        <span class="actions-sep" aria-hidden="true"></span>
        <button type="button" class="btn-round" title="راهنما" aria-label="راهنما" (click)="showHelp()">
          <i class="fa fa-question" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="collapsible" id="filtersWrap" [class.collapsed]="!filtersOpen">
      <div class="collapsible-inner">
        <div class="filters">
          <div class="field" [formGroup]="dataFrom">
            <label class="field-label" for="startDate">از تاریخ</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
              [dateFormat]="'jYYYY/jMM/jDD'">
              <input id="startDate" type="text" formControlName="date" class="control num" readonly />
            </ng-persian-datepicker>
          </div>
          <div class="field" [formGroup]="dataTo">
            <label class="field-label" for="endDate">تا تاریخ</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
              [dateFormat]="'jYYYY/jMM/jDD'">
              <input id="endDate" type="text" formControlName="date" class="control num" readonly />
            </ng-persian-datepicker>
          </div>
          <label class="field" for="domainDashbord">
            <span class="field-label">حوزه خدمت</span>
            <select class="control" id="domainDashbord" [(ngModel)]="iMobileDomain">
              <option value="-1">انتخاب کنید</option>
              <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
            </select>
          </label>
          <div class="field">
            <label class="field-label" for="Stime">از ساعت</label>
            <input type="time" class="control num" id="Stime" [formControl]="strSTime" />
          </div>
          <div class="field">
            <label class="field-label" for="Etime">تا ساعت</label>
            <input type="time" class="control num" id="Etime" [formControl]="strETime" />
          </div>
          <label class="field" for="carGroup">
            <span class="field-label">نوع شناور</span>
            <select id="carGroup" class="control" [(ngModel)]="tiMobileType">
              <option value="-1">نمایش همه</option>
              <option *ngFor="let item of groupCar" value="{{item.tiMobileType}}">{{item.strComment}}</option>
            </select>
          </label>
          <div class="filter-actions">
            <button type="button" class="btn btn-primary" (click)="search()" [disabled]="loading">
              <i class="fa fa-search" aria-hidden="true"></i> به روز رسانی
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <div class="dashboard-grid" [attr.aria-busy]="loading">
    <section class="card dashboard-chart dashboard-chart--wide">
      <div>
        <app-chart [context]="powerChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart dashboard-chart--wide">
      <div>
        <app-chart [context]="fuelConsumptionChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart dashboard-chart--wide">
      <div>
        <app-chart [context]="prolificBoatsChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart dashboard-chart--wide">
      <div class="dashboard-tree-scroll">
        <app-chart [context]="boatStatisticsChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart dashboard-chart--wide">
      <div class="dashboard-tree-scroll">
        <app-chart [context]="boatStatusChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart dashboard-chart--wide">
      <div class="dashboard-map-heading">
        <h2 class="dashboard-card-title">نقشه پراکندگی شناورها</h2>
      </div>
      <div class="dashboard-map">
        <div id="test" class="fixed-mapCluster" role="region" aria-label="نقشه پراکندگی شناورها">
          <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>
        </div>
      </div>
    </section>
  </div>
</div>
